__webpack_require__.p = "https://certificate.quantstamp.com/full/startale-stablecoin-vaults/402c94ac-7cc8-4b28-94b0-83876f38cf56/";